
import { ProjectService } from './service';

function initialState()
{
    return {
        item: [],
        loading: false
    }
}

const getters = {
    item: state => state.item,
    gallery: state => state.item.gallery || [],
    related: state => state.item.related || [],
    mainImage: state => (state.item.gallery ? state.item.gallery[0] : false),
    loading: state => state.loading
};

const actions = {
    fetch({ commit, dispatch, state }, slug) {
        commit('setLoading', true);
        return new Promise((resolve, reject) => {
            ProjectService.fetch(slug)
                .then(response => {
                    commit('setItem', response.data.data);
                    resolve()
                })
                .catch(error => {
                    console.error(error);
                    reject(error)
                })
                .finally(() => {
                    commit('setLoading', false)
                })
        });
    },
    resetState({ commit }) {
        commit('resetState')
    }
};

const mutations = {
    setItem(state, item) {
        state.item = item;
    },
    setLoading(state, loading) {
        state.loading = loading
    },
    resetState(state) {
        state = Object.assign(state, initialState())
    }
};

export default {
    namespaced: true,
    state: initialState,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./resources/js/store/modules/Projects/single.js